// extracted by mini-css-extract-plugin
export default {"left_content_wrapper":"Revenue_left_content_wrapper__vD4hf","dropdown_wrapper":"Revenue_dropdown_wrapper__0S0aU","no_data_wrapper":"Revenue_no_data_wrapper__TTbyC"};